export default {
    Calculator: 'Kalkulator',
    'Calculator configurator': 'Konfigurator kalkulatora',
    'Calculator type': 'Tip kalkulatora',
    'Calculator rules': 'Pravila za kalkulator',
    'Customer Data': 'Podaci o korisniku',
    'Customer data': 'Podaci o korisniku',
    Offer: 'Ponuda',
    Graphs: 'Grafikoni',
    'Offer overview': 'Pregled ponuda',
    'Offer calculation preview': 'Pregled kalkulacije',
    Calculation: 'Kalkulacija',
    Created: 'Kreirano',
    'Type of Customer': 'Tip kupca',
    'Company Name': 'Ime preduzeća',
    PIB: 'PIB',
    MB: 'MB',
    BAN: 'BAN',
    JMBG: 'JMBG',
    'Upload Usage File': 'Otpremi datoteku korišćenja',
    'Master calculation': 'Izračunavanje mastera',
    'Existing Call Mix': 'Postoji Call Mix',
    'E-mail': 'E-mail',
    'Offer type': 'Tip ponude',
    'Account type': 'Tip korisnika',
    Renewal: 'Obnova ugovora',
    Acquisition: 'Novi ugovor',
    'Add HW': 'Dodaj HW',
    AddHw: 'Dodavanje HW',
    AddSim: 'Dodavanje SIM',
    'Number of Voice SIM': 'Broj SIM kartica',
    'Minimum amount': 'Minimalna količina',
    'Maximum amount': 'Maksimalna količina',
    'Due date': 'Valuta plaćanja',
    'Bill rounding': 'Zaokruživanje naplate razgovora',
    'BAN level discount': 'Popust na ukupan račun',
    'Other services': 'Ostali troškovi',
    'Tariff fee': 'Mesečna pretplata po SIM kartici',
    'Tariff discount': 'Popust na pretplatu',
    'Total fee': 'Ukupni račun',
    Bill: 'Račun',
    'International traffic': 'Tarifa za međunarodni saobraćaj',
    'Balkan zone': 'Balkan zona',
    'Change of Terms': 'Promena uslova',
    Duration: 'Trajanje',
    Start: 'Početak',
    End: 'Završetak',
    Portfolio: 'Portfolio',
    Unlimited: 'Neograničen',
    Package: 'Paket',
    'List of formulae': 'Lista formula',
    Rule: 'Pravilo',
    'Rule definition': 'Definicija pravila',
    'Formula definition': 'Definicija formule',
    'Formula name': 'Naziv formule',
    'Custom variables': 'Proizvoljne varijable',
    'Predefined variables': 'Predefinirane varijable',
    TPM: 'Telefon po meri',
    HWB: 'Hardware budget',
    VPN: 'VPN',
    GLOBAL: 'Global',
    Tpm: 'Telefon po meri',
    Hwb: 'Hardware budget',
    Vpn: 'VPN',
    Type: 'Tip',
    Dimension: 'Dimenzija',
    'Sim Cards': 'Broj kartica',
    Price: 'Cena',
    'Wanted Price': 'Željena cena',
    'Single price': 'Jedinična cena',
    Select: 'Izaberi',
    Strategic: 'Strateški',
    Tender: 'Tender',
    Other: 'Ostali',
    'Total per SIM': 'Iznos pretplate po SIM kartici',
    Total: 'Total',
    Totals: 'Total',
    Option: 'Dodatak',
    Hardware: 'Uređaj',
    Tariff: 'Tarifa',
    Tariffs: 'Tarife',
    Description: 'Opis',
    Quantity: 'Količina',
    'Additional BANs': 'Dodatni BAN',
    'Additional Payment': 'Dodatno plaćanje',
    'Additional charges': 'Dodatne pogodnosti',
    Budget: 'Budžet',
    'Full Budget': 'Ceo budžet',
    'Customer Agreed Budget': 'Dogovoreni budžet kupca',
    'Monthy Subscription': 'Mesečna pretplata',
    'With VDC': 'Sa VDC i odabranim dodacima',
    'Without VDC': 'Bez VDC i odabranim dodacima',
    'Monthly with VDC': 'Mesečna pretplata sa VDC i odabranim dodacima',
    'Monthly without VDC': 'Mesečna pretplata bez VDC i odabranih dodataka',
    'Customer Agreed VDC': 'VDC dogovoren s korisnikom',
    'Agreed VDC': 'Dogovoren VDC',
    Discount: 'Popust',
    Volume: 'Volumen',
    Preferred: 'Željeni',
    'Section Budget': 'Budžet',
    'Total financial budget': 'Ukupni finansijski budžet',
    'Total budget': 'Ukupni budžet',
    'Budget agreed with user': 'Budžet dogovoren s korisnikom',
    'Enter budget manually': 'Ručni unos budžeta',
    Fetch: 'Dohvati',
    'Choose File': 'Odaberi dokument',
    'Load file locally': 'Učitaj dokument za preuzimanje',
    'Attached files': 'Dodani dokumenti',
    'Choose files': 'Priloži dokumente',
    'Number of files': 'Broj dokumenata',
    Upload: 'Dodaj dokument',
    'Upload successfull': 'Dokument je sačuvan',
    'Upload failed': 'Čuvanje nije uspjelo',
    'Deleting document': 'Brisanje dokumenta u tijeku',
    'File deleted successfully': 'Dokument je uspešno obrisan',
    'No attached files': 'Nema pridruženih dokumenata',
    Ready: 'Učitano',
    'Download file': 'Preuzmi dokument',
    'Download failed': 'Preuzimanje nije uspelo',
    'Delete file': 'Obiši dokument',
    'Delete failed': 'Brisanje nije uspelo',
    Update: 'Ažuriraj',
    Add: 'Dodaj',
    Save: 'Sačuvaj',
    Send: 'Pošalji',
    Discard: 'Poništi',
    Approve: 'Odobri',
    Deny: 'Zabrani',
    Continue: 'Nastavi',
    Hold: 'Na čekanju',
    Print: 'Štampanje',
    'Print PDF': 'PDF ponuda',
    'Print Offer': 'Štampanje ponude',
    Dashboard: 'Dashboard',
    Search: 'Pretraži',
    'Add Offer': 'Kreiraj ponudu',
    Configurator: 'Konfigurator',
    Portfolios: 'Portfolio',
    'Report KPI': 'KPI',
    'Report MDS': 'MDS',
    'Report SME': 'SME izveštaj',
    'SME Offer': 'SME ponuda',
    'VPN Offer': 'VPN ponuda',
    'List of offers': 'Pregled ponuda',
    Open: 'Otvorena',
    Closed: 'Zatvorena',
    WaitingForApproval: 'Čeka se odobrenje',
    Won: 'Prihvaćena ponuda',
    Lost: 'Odbijena ponuda',
    Draft: 'Ponuda u pripremi',
    'Sent to customer': 'Poslato korisniku',
    SentToCustomer: 'Poslato korisniku',
    Prepared: 'Spremna ponuda',
    Sent: 'Ponuda poslata',
    Canceled: 'Korisnik je odustao od ponude',
    'Please select hardware': 'Izaberi uređaj',
    'Please enter wanted price': 'Unesi željenu cenu',
    'Preferred discount': 'Dodeljeni popust',
    'Please select Internet dodatak': 'Izaberite Internet dodatak',
    'Please select Podeli Net': 'Izaberite Podeli Net',
    'Please enter number larger than 0': 'Unesite broj veći od 0',
    'This will reset the offer, are you sure?': 'Ovo će resetovati ponudu, jesi li siguran?',
    'This will copy the offer, are you sure?': 'Ovo će kopirati ponudu, jesi li siguran?',
    'This will delete the package, are you sure?': 'Ovo će izbrisati paket, jesi li siguran?',
    'This will delete hardware from list, are you sure?': 'Ovo će izbrisati hardver sa liste, jeste li sigurni?',
    'This will delete the attachment, are you sure?': 'Ovo će izbrisati dokument iz ponude, jeste li sigurni?',
    'Error saving offer': 'Greška pri čuvanju ponude',
    'Offer saved': 'Sačuvana ponuda',
    'Offer needs review': 'Ponudu treba pregledati',
    'Offer is not possible': 'Ponuda nije moguća',
    'Offer is possible': 'Ponuda je moguća',
    Copy: 'Kopija',
    Default: 'Osnovni',
    Fetched: 'Dohvaćeni',
    Edited: 'Izmenjeni',
    'Optional status message': 'Opcionalna statusna poruka',
    'Mega Menu': 'Mega meni',
    Menu: 'Izbornik',
    Calendar: 'Kalendar',
    Chat: 'Pričaonica',
    Ecommerce: 'Elektronska trgovina',
    Products: 'Proizvodi',
    'Product Detail': 'Detalji o proizvodima',
    Orders: 'Narudžbe',
    Customers: 'Kupci',
    Customer: 'Korisnik',
    Cart: 'Korpa',
    Checkout: 'Odjava',
    Shops: 'Prodavnice',
    'Add Product': 'Dodajte proizvod',
    Email: 'Email',
    Inbox: 'Inbox',
    'Read Email': 'Čitati poštu',
    'Kanban Board': 'Kanban tabla',
    Layouts: 'Pregledi',
    Horizontal: 'Horizontalno',
    'Dark Sidebar': 'Tamni bočni prozor',
    'Default Sidebar': 'Pretpostavljeni bočni prozor',
    'Compact Sidebar': 'Kompaktni bočni prozor',
    'Icon Sidebar': 'Ikona bočnog prozora',
    'Boxed Layout': 'Boxed Layout',
    'Fluid Layout': 'Fluid Layout',
    Preloader: 'Preloader',
    'Without Preloader': 'Bez preloader',
    Pages: 'Stranice',
    Authentication: 'Autentikacija',
    Login: 'Prijavite se',
    Register: 'Registrovajte se',
    'Recover Password': 'Obnovi lozinku',
    'Lock Screen': 'Zaključavanje ekrana',
    Utility: 'Utility',
    'Starter Page': 'Početna stranica',
    Maintenance: 'Održavanje',
    'Coming Soon': 'Dolazi uskoro',
    Timeline: 'Vremenska linija',
    FAQs: 'Česta pitanja',
    Pricing: 'Cenik',
    'Error 404': 'Greška 404',
    'Error 500': 'Greška 500',
    Components: 'Komentari',
    'UI Elements': 'UI elementi',
    Alerts: 'Alerts',
    Buttons: 'Buttons',
    Cards: 'Cards',
    Carousel: 'Karusel',
    Dropdowns: 'Dropdowns',
    Grid: 'Rešetka',
    Images: 'Slike',
    Lightbox: 'Lightbox',
    Modals: 'Modali',
    'Range Slider': 'Klizač dometa',
    'Round Slider': 'Okrugli klizač',
    'Session Timeout': 'Cremensko ograničenje sesije',
    'Progress Bars': 'Trake napredka',
    'Sweet Alerts': 'Sweet Alerts',
    'Tabs & Accordions': 'Tabulatori i harmonika',
    Typography: 'Tipografija',
    Video: 'Video',
    General: 'Generalno',
    Rating: 'Ocena',
    Notifications: 'Obaveštenja',
    Forms: 'Obrasci',
    Elements: 'Elementi',
    Validation: 'Validacija',
    'Advanced Plugins': 'Advanced Plugins',
    Editors: 'Editors',
    'File Upload': 'Otpremanje datoteke',
    'X-editable': 'X-editable',
    Wizard: 'Pomoćnik',
    Mask: 'Maska',
    Tables: 'Tabela',
    'Basic Tables': 'Osnovne tabele',
    'Data Tables': 'Data tabele',
    'Responsive Table': 'Responzivne tabele',
    'Editable Table': 'Tabele za uređivanje',
    Charts: 'Grafikoni',
    Apexcharts: 'Apexcharts',
    Chartist: 'Chartist',
    Chartj: 'Chartj',
    'Jquery Knob': 'Jquery Knob',
    Sparkline: 'Sparkline',
    Icons: 'Ikone',
    'Remix Icons': 'Remix ikone',
    'Material Design': 'Material dizajn',
    Dripicons: 'Dripicons',
    'Font awesome 5': 'Font awesome 5',
    Maps: 'Mape',
    'Google Maps': 'Google Maps',
    'Vector Maps': 'Vector Maps',
    'Multi Level': 'Više nivoa',
    'Level 1.1': 'Nivo 1.1',
    'Level 1.2': 'Nivo 1.2',
    'Level 2.1': 'Nivo 2.1',
    'Level 2.2': 'Nivo 2.2',
    Profile: 'Profil',
    'My Wallet': 'Moj novčanik',
    Settings: 'Podešavanja',
    'View more': 'Pogledaj više',
    'View all': 'Pogledaj sve',
    Logout: 'Odjavite se',
    'Your order is placed': 'Vaša narudžba je izvršena',
    'If several languages coalesce the grammar': 'Ako nekoliko jezika spaja gramatiku',
    'Your item is shipped': 'Vaša stavka je isporučena',
    '3 min ago': 'Pre 3 minuta',
    'James Lemire': 'Džejms Lemir',
    'It will seem like simplified English.': 'Izgledac̘e kao pojednostavljeni engleski.',
    '1 hours ago': 'Pre 1 sat',
    'Salena Layfield': 'Salena Lajfild',
    'As a skeptical Cambridge friend of mine occidental.': 'Kao moj skeptični prijatelj sa Kembridža.',
    'View More..': 'Pogledaj još..',
    'UI Components': 'UI Components',
    Applications: 'Aplikacije',
    'Extra Pages': 'Dodatne stranice',
    Github: 'Github',
    Bitbucket: 'Bitbucket',
    Dribble: 'Dribble',
    Dropbox: 'Dropbox',
    'Mail Chimp': 'Mail Chimp',
    Slack: 'Slack',
    'Add new portfolio': 'Dodaj novi portfolio',
    'Add tariff': 'Dodaj tarifu',
    'Add options': 'Dodaj dodatak',
    Overview: 'Pregled',
    Administration: 'Administracija',
    'Option group': 'Grupa dodataka',
    'Option value': 'Vrednost dodatka',
    'Option content': 'Sadržaj dodatka',
    Name: 'Naziv',
    'Rule name': 'Naziv pravila',
    'Copied rule name': 'Naziv kopiranog pravila',
    'Valid for': 'Važi za',
    Notes: 'Napomene',
    Note: 'Napomena',
    'Package name': 'Naziv dodatka',
    Level: 'Nivo',
    Subsidy: 'Subsidy',
    Margin: 'Margina',
    Cancel: 'Otkaži',
    Previous: 'Prethodna',
    Next: 'Sledeća',
    Active: 'Aktivan',
    'Active rule': 'Aktivno pravilo',
    'Inactive rule': 'Neaktivno pravilo',
    Yes: 'Da',
    No: 'Ne',
    Options: 'Dodaci',
    'Options (On Top)': 'Dodaci (On Top)',
    'Group to application role mapping': 'Groupe i role',
    'Select role': 'Odaberi rolu',
    'Add group': 'Dodaj grupu',
    'Role mapping': 'Mapiranje rola',
    User: 'User',
    State: 'Status',
    Status: 'Komentar',
    All: 'Sve',
    Offers: 'Ponude',
    'Offer status': 'Status ponude',
    'Portfolio share': 'Portfolio share',
    Range: 'Raspon',
    Date: 'Datum',
    Day: 'Dan',
    Week: 'Nedelja',
    Month: 'Mesec',
    '3 months': '3 meseca',
    '6 months': '6 meseci',
    Year: 'Godina',
    Comment: 'Komentar',
    Admin: 'Administrator',
    Manager: 'Menadžer',
    'Regional manager': 'Regionalni menadžer',
    'Account manager': 'Predstavnik prodaje',
    Value: 'Vrednost',
    Comparator: 'Porednik',
    'Company name': 'Ime kompanije',
    'Total amount': 'Ukupna suma',
    'In bundle': 'U paketu',
    Bundle: 'Paket',
    Bundles: 'Paketi',
    'Offer details': 'Detalji ponude',
    'Bundle discount': 'Popust na dodatak',
    'Bundle name': 'Naziv dodatka',
    'Add package': 'Dodaj paket',
    'Edit package': 'Ažuriraj paket',
    'Edit price list': 'Cenovnik saobraćaja',
    'Not saved': 'Nije sačuvano',
    'Admin approval': 'Odobrenje administratora',
    'Price per SIM': 'Cena za SIM',
    'User note': 'Dodatne pogodnosti/odobrenja za korisnika',
    'Offer search': 'Pretraga ponuda',
    'Offer filter': 'Filter ponuda',
    'Customer filter': 'Filter prema korisniku',
    'Tariff price': 'Cena uz tarifu',
    'Wanted price': 'Cena željena',
    'Search pending': 'Pretraga je u tijeku',
    'Search finished': 'Pretraga je završena',
    'Date from': 'Od datuma',
    'Date to': 'Do datuma',
    'Search results': 'Rezultati pretrage',
    'Offer search error': 'Greška pri pretrazi',
    'Export to CSV': 'Izvoz u CSV',
    'Enter username': 'Unesite korisničko ime',
    'Enter password': 'Unesite lozinku',
    'Username is required': 'Korisničko ime je potrebno',
    'Password is required': 'Lozinka je potrebna',
    'Remember me': 'Zapamti me',
    'Log In': 'Prijavite se',
    'Sign in': 'Prijava',
    Username: 'Korisničko ime',
    Password: 'Lozinka',
    'Full name': 'Ime i prezime',
    'User profile': 'Korisnički profil',
    'Invalid username or password': 'Pogrešno korisničko ime ili lozinka',
    'Offer Calculator': 'Digitalni kalkulator',
    'Add rule': 'Dodaj pravilo',
    'Test rule': 'Testiraj pravilo',
    'Delete rule': 'Obriši pravilo',
    'Save rule': 'Spremi pravilo',
    'Save formula': 'Spremi formulu',
    'Update formula': 'Ažuriraj formulu',
    'Test in progress': 'Provjera u tijeku',
    'Up to date': 'Ažurno',
    'No formula': 'Nema formule',
    'No variables': 'Nema varijabli',
    'Add formula': 'Dodaj formulu',
    'Clear operations': 'Obriši operacije',
    'Clear last operation': 'Obriši posljednju operaciju',
    'Rule validation status': 'Status validacije pravila',
    Untested: 'Netestirano',
    Invalid: 'Neuspešna validacija',
    Valid: 'Validirano',
    Variable: 'Varijabla',
    Formula: 'Formula',
    Parameter: 'Parametar',
    'Add variable': 'Dodaj varijablu',
    'View filters': 'Filteri pregleda',
    'Add filter': 'Dodaj filter',
    'Math operation': 'Računska operacija',
    'Logic operation': 'Logička operacija',
    'Add operation': 'Dodaj operaciju',
    'Edit rule settings': 'Definiši postavke pravila',
    'Edit formula settings': 'Uredi postavke formule',
    'Operation between blocks': 'Operacija između blokova',
    'Calculus operation': 'Računska operacija',
    'Logical operation': 'Logička operacija',
    Operation: 'Operacija',
    Property: 'Svojstvo',
    Result: 'Rezultat',
    'No offers that meet this conditions.': 'Nije pronađena ponuda prema zadanim uvetima.',
    Operands: 'Operandi',
    Reduction: 'Redukcija',
    Position: 'Pozicija',
    'Position from': 'Od pozicije',
    'Position to': 'Do pozicije',
    From: 'Od',
    To: 'Do',
    'Value from': 'Od vrednosti',
    'Value to': 'Do vrednosti',
    'From date': 'Od datuma',
    'To date': 'Do datuma',
    'Add result': 'Dodaj rezultat',
    'Added results': 'Dodani rezultati',
    'No results added': 'Nema dodanih rezultata',
    'Define a result': 'Definiši rezultat',
    'No rules': 'Nema pravila',
    'Choose a calculator type and add or choose a rule to edit.': 'Odaberi kalkulator i dodaj ili odaberi pravilo za konfiguraciju.',
    'Choose a calculator type to copy the rule into.': 'Odaberi tip kalkulatora u koji želiš kopirati pravilo',
    'Pick an operation to define a formula.': 'Odaberi tip operacije za početak definiranja formule.',
    'No log was generated as output for the current rule.': 'Nema zabilješke rezultata testa za trenutno pravilo.',
    'No log was generated as calculation output for the offer.': 'Nema zabilješke rezultata kalkulacije za ponudu.',
    'Variable with the same name already exists.': 'Postoji varijabla s ovim nazivom.',
    'No calculus definition': 'Formula nema računske definicije',
    'No logical definition': 'Formula nema logičke definicije',
    'No formulae': 'Pravilo nema postavljene formule',
    'Offer Purpose': 'Tip ponude',
    'Print note': 'Napomena za korisnika',
    'Add portfolio': 'Dodaj portfolio',
    'All portfolios': 'Svi portfelji',
    'Tariff type': 'Tip tarife',
    ChangeTerms: 'Promena uslova ugovora',
    'Volume discount': 'Pripadajući popust',
    'On Top': 'Dodaci van paketa',
    RegionalManager: 'Regionalni menadžer',
    AccountManager: 'Predstavnik prodaje',
    'Choose hardware': 'Izbor uređaja',
    'Calculation type': 'Tip kalkulacije',
    'Edit options': 'Izmeni dodatke',
    'Edit option': 'Izmeni dodatak',
    'Edit value': 'Izmeni vrednost',
    'Option values overview': 'Pregled vrednosti na dodatku',
    'Option overview': 'Pregled dodataka',
    'Show inactive': 'Prikaži neaktivne',
    'No group selected': 'Grupa nije odabrana',
    Configuration: 'Konfiguracija',
    'Hardware price': 'Cena uređaja',
    'Hardware count': 'Broj uređaja',
    'Option type': 'Vrsta dodatka',
    'Bundle type': 'Tip dodatka',
    Amount: 'Količina',
    'Add tariff prices': 'Dodaj cene za tarife',
    Edit: 'Izmeni',
    'Added tariffs and prices': 'Dodate tarife i cene',
    Groups: 'Grupe',
    Group: 'Grupa',
    'Save option': 'Sačuvaj dodatak',
    'Save changes': 'Sačuvaj promene',
    'Add option': 'Dodaj dodatak',
    'Add option group': 'Dodaj grupu dodataka',
    'Reset filter': 'Poništi filtere',
    'Add value': 'Dodaj vrednost',
    'No entries': 'Nema zapisa',
    'Max discount': 'Max popust',
    'Entry tariff discount': 'Popust na entry tarifu',
    'Limit amount': 'Iznos limita',
    'Number of sim cards with limit': 'Broj kartica za koje se setuje limit',
    'Number of sim tariff one minute': 'Broj kartica sa 1/1 tarifiranjem',
    'System values': 'Sistemske vrednosti',
    'Value type': 'Tip vrednosti',
    'System value': 'Sistemska vrednost',
    Constants: 'Konstante',
    'Add system value': 'Dodaj sistemsku vrednost',
    'Edit system value': 'Izmeni sistemsku vrednost',
    'SIM number': 'Broj kartica',
    'Total hardware price': 'Ukupna vrednost odabranih uređaja',
    'Total wanted price': 'Ukupna željena cena',
    Surcharge: 'Doplata',
    'Surcharge for selected HW': 'Doplata za izabrane uređaje',
    'Financial budget': 'Finansijski budžet',
    Platinum: 'Platinum',
    Green: 'Zeleni',
    Orange: 'Narandžasti',
    Red: 'Crveni',
    'No segment': 'Bez segmenta',
    'Start of contract': 'Početak ugovorne obaveze',
    'End of contract': 'Kraj ugovorne obaveze',
    'Hardware budget price': 'Budžetska cena uređaja',
    'HW wanted price': 'Željena cena uređaja',
    'Monthly subscription': 'Mesečna pretplata',
    'Option name': 'Naziv dodatka',
    National: 'Nacionalni',
    International: 'Međunarodni',
    Roaming: 'Roming',
    Data: 'Internet',
    'National options': 'Nacionalni dodaci',
    'International options': 'Internacionalni dodaci',
    'Roaming options': 'Roming dodaci',
    'Option price': 'Cena dodatka',
    'Option amount': 'Broj dodataka',
    'SIM amount': 'Broj kartica',
    'Discount price': 'Cena s popustom',
    'Bundled option': 'Dodaci u paketu',
    'Option discount': 'Popust za dodatak',
    'Total tariff price': 'Ukupna cena paketa',
    'Total price': 'Ukupna cena',
    'Total SIM number': 'Ukupan broj kartica',
    'Total wanted surcharge': 'Ukupna željena doplata uređaja',
    'Client segment': 'Segment korisnika',
    'Total monthy subscription': 'Ukupna mesečna pretplata',
    'Message for agent': 'Upiši dodatne pogodnosti za korisnika',
    'Duration of contract': 'Ugovorna obaveza',
    'Remaining financial budget': 'Preostali finansijski budžet',
    String: 'Tekst',
    Number: 'Broj',
    Boolean: 'Tačno/Netačno',
    'Portfolio name': 'Naziv portfolia',
    'Portfolio note': 'Napomena za portfolio',
    'Tariff name': 'Naziv tarife',
    'Tariff level': 'Nivo tarife',
    'Tariff group': 'Grupa tarife',
    'Option editing': 'Konfiguracija dodataka',
    'On Top subsidy': 'On top budget - subsidy',
    'List of calculators': 'Lista kalkulatora i kalkulacija',
    Info: 'Info',
    Warning: 'Upozorenje',
    'View All': 'Prikaži sve',
    'View More': 'Prikaži više',
    Message: 'Poruka',
    'No notifications': 'Nema obaveštenja',
    'Confirm save': 'Potvrdi čuvanje',
    'No customer found': 'Korisnik nije pronađen',
    Close: 'Zatvori',
    Show: 'Prikaži',
    'Group prices': 'Cene po grupama',
    'Base price': 'Osnovna cena',
    'Budget price': 'Budžetska cena',
    'EUR price': 'Cena u eurima',
    'Marketing support': 'Marketinška podrška',
    'Offer must be approved': 'Ponuda mora na odobrenje',
    'In VDC field, enter the VDC that the user follows based on the total number of cards on the BAN': 'U pripadajući popust unesite VDC koji korisniku sleduje na osnovu ukupnog broja kartica na BAN-u',
    'Require approval': 'Zatraži odobrenje',
    'Please enter BAN, PIB, MB or PGB': 'Unesite BAN, PIB, MB ili PGB',
    'Offer editing': 'Priprema ponude',
    'Offer is readonly, locked by ': 'Ponuda je samo za pregledavanje, zaključana od strane ',
    'Offer is valid': 'Ponuda je moguća',
    'Offer is not valid': 'Ponuda nije moguća',
    'Unlock offer': 'Otključaj ponudu',
    'Offer unlocked': 'Ponuda otključana',
    'Unlock successfull': 'Ponuda otključana',
    'Unlock failed': 'Neuspešno otključavanje ',
    'Error unlocking offer': 'Greška pri otključavanju ponude',
    'Tariff hwardware price': 'Cena uređaja u tarifi',
    'Download report': 'Preuzmi izveštaj',
    'SME Report': 'SME izveštaj',
    'Hardware ID': 'Kod uređaja',
    'Hardware name': 'Model uređaja',
    'Hardware amount': 'Količina uređaja',
    'Hardware map price (eur)': 'MAP cena uređaja',
    'Option discount price': 'Cena dodatka s popustom',
    'Sales name': 'Ime agenta',
    'Sales role': 'Rola agenta',
    'Report message': 'Report poruka',
    'Offer ID': 'ID ponude',
    'Finance VDC': 'Pripadajući VDC',
    'Defined budget': 'Odobreni budžet',
    'Budget defined with customer': 'Dogovoreni budžet sa korisnikom',
    'Prepare report': 'Pripremi izveštaj',
    Download: 'Preuzimanje',
    'SME report fetched': 'SME izveštaj je preuzet',
    Loading: 'Učitavanje',
    'Loading offer': 'Učitavanje ponude',
    'Loading done': 'Učitavanje dovršeno',
    'Offer load failed': 'Greška kod učitavanja ponude',
    'Offer approved by': 'Ponuda odobrena od strane',
    'Offer approved': 'Ponuda odobrena',
    'Offer needs approval': 'Potrebno odobrenje',
    'Offer was audited': 'Ponuda pregledana',
    'Calculation started': 'Kalkulacija ponude',
    'Calculation done': 'Kalkulacija je završena',
    by: 'od strane',
    'Sales full name': 'Puno ime agenta',
    'New offer': 'Nova ponuda',
    'Quantity budget': 'Količinski budžet',
    'Total finance budget per offer': 'Ukupan budžet po ponudi',
    'Won and lost offers': 'Prihvaćene i odbijene ponude',
    'No records found': 'Nije pronađen nijedan zapis',
    'In maintenance': 'U održavanju',
    'Maintenance notification': 'Obaveštenje o održavanju',
    'Wanted price for approval': 'Minimalna doplata uređaja',
    Disabled: 'Onemogućeno',
    Enabled: 'Omogućeno',
    Notice: 'Obaveštenje',
    'System value saved successfully': 'Sistemska vrednost je uspešno sačuvana',
    'System value updated successfully': 'Sistemska vrednost je uspešno ažurirana',
    'Traffic type': 'Vrsta saobraćaja',
    Unit: 'Jedinica',
    Units: 'Jedinice',
    'Unit type': 'Vrsta jedinice',
    'Price per unit': 'Cena po jedinici',
    'Actual usage': 'Tip saobraćaja',
    'Time validation': 'Vremenska validacija',
    'User role': 'Rola korisnika',
    Advanced: 'Napredno',
    'Used in calculation': 'Koristi se unutar kalkulacije',
    'Select enum from list': 'Izaberite enum sa liste',
    Size: 'Veličina',
    Values: 'Vrednosti',
    Properties: 'Svojstva',
    'Product segment': 'Segment proizvoda',
    PriceWithDiscount: 'Cena s popustom',
    TotalPrice: 'Ukupna cena',
    OptionProfile: 'VPN profil',
    'Option profile': 'Profil dodatka',
    'Bundle profile': 'VPN profil',
    'Price per option': 'Cena dodatka',
    DiscountedPrice: 'Cena s popustom',
    'Discounted price': 'Cena s popustom',
    TotalDiscountPrice: 'Ukupna s popustom',
    'Total Discount Price': 'Ukupna s popustom',
    'Offer content': 'Sadržaj ponude',
    'The offer has no added bundles': 'Ponuda nema dodanih paketa',
    'Add to list': 'Dodaj',
    'Add bundle': 'Sačuvaj paket',
    'Add bundles': 'Sačuvaj pakete',
    'Data package': 'Internet dodatak',
    'Add hardware': 'Dodaj uređaj',
    Classic: 'Klasik',
    Internal: 'Interni',
    'Offer comments': 'Komentari na ponudu',
    'Admin comments': 'Admin komentari',
    'Admin comment': 'Komentar admina',
    'Controlling comment': 'Komentar kontrolinga',
    'Search term': 'Pojam pretrage',
    'Select opportunity': 'Odaberi opportunity',
    Submit: 'Pošalji',
    'Show notes': 'Pokaži komentare',
    'Show calculation': 'Pokaži izračun',
    'Basic parameters': 'Osnovne karakteristike',
    'Added options': 'Dodani dodaci',
    loaded: 'učitan',
    'no VAT': 'bez PDV-a',
    'Monthly fees': 'Mesečna pretplata',
    VoicePackages: 'Voice paketi',
    SmsPackages: 'SMS paketi',
    DataPackages: 'Data paketi',
    InternationalPackages: 'Internacionalni paketi',
    RoamingPackages: 'Roaming paketi',
    MonthlyFeePerSim: 'Mesečna SIM naknada',
    MonthlyFeePerSimTotal: 'Ukupna mesečna SIM naknada',
    TotalMonthlyFee: 'Ukupna mesečna pretplata',
    'Voice fees': 'Obračun Voice saobraćaja',
    NationalVoice: 'Nacionalni Voice',
    InternationalVoice: 'Internacionalni Voice',
    RoamingVoiceOutbound: 'Roaming Voice odlazni',
    RoamingVoiceInbound: 'Roaming Voice dolazni',
    TotalVoiceTrafficFee: 'Voice saobraćaj ukupno',
    'Sms fees': 'Obračun SMS saobraćaja',
    NationalSms: 'SMS Nacionalni',
    InternationalSms: 'SMS Internacionalni',
    RoamingSms: 'SMS Roaming',
    TotalSmsTrafficFee: 'SMS saobraćaj ukupno',
    'Data fees': 'Obračun Data saobraćaja',
    NationalData: 'Data Nacionalni',
    RoamingData: 'Data Roaming',
    TotalDataTrafficFee: 'Data saobraćaj ukupno',
    'Budget fees': 'Budžet',
    FinanceBudget: 'Finansijski budžet',
    VolumeBudgetVoice: 'Količinski budžet Voice',
    TotalBudgetFee: 'Ukupni budžet',
    'Fixed fees': 'Fiksni troškovi',
    UnamortizedCost: 'Neamortizovani trošak',
    Cashback: 'Cash back',
    OtherServices: 'Ostali troškovi',
    'Traffic totals': 'Prihodi i troškovi po osnovu saobraćaja',
    InterconnectionRevenue: 'Prihodi interkonekcije',
    InterconnectionCosts: 'Troškovi interkonekcije',
    RoamingCosts: 'Troškovi roaminga',
    TotalTrafficFee: 'Ukupni prihodi/troškovi po osnovu saobraćaja',
    'Subsidy totals': 'Subsidy i fiksni troškovi',
    SubsidyVolumeBudgetVoice: 'Subsidy za količinski budžet Voice',
    SubsidyFinanceBudget: 'Subsidy za finansijski budžet',
    TotalHardwareSubsidy: 'Ukupni subsidy za hardver',
    TotalFixedFees: 'Ukupni fiksni troškovi',
    TotalSubsidy: 'Ukupni subsidy i fiksni troškovi',
    MonthlySubsidy: 'Mesečni subsidy i fiksni troškovi',
    'Margin totals': 'Margina',
    VoiceMarginI: 'Voice M I',
    VoiceMarginII: 'Voice M II',
    BlendedMarginI: 'Blended M I',
    BlendedMarginII: 'Blended M II',
    LifetimeTotalRevenue: 'Lifetime Prihod',
    LifetimeTotalBlendedMargin: 'Lifetime Margina',
    'Bill totals': 'Pregled računa',
    TotalBill: 'Račun',
    BillDiscount: 'Popust na račun',
    TotalBillWithDiscount: 'Ukupni račun',
    FeesTotal: 'Ukupna naknada',
    VolumeBudget: 'Količinski budžet',
    TotalBudget: 'Ukupni budžet',
    TotalFees: 'Ukupne naknade',
    serviceGroup: 'Grupa',
    unit: 'Jedinica',
    featureCode: 'Kod',
    discountedValue: 'Cena',
    usageType: 'Tip saobraćaja',
    serviceType: 'Tip paketa',
    dataType: 'Tip prometa',
    maxValue: 'Maksimalna vrednost',
    airtimeValue: 'Air time value',
    activeVal: 'Aktivna vrednost',
    passiveVal: 'Pasivna vrednost',
    zone: 'Zona',
    discountPercent: 'Postotak popusta',
    preferredPartner: 'Preferirani partner',
    'Default CallMix fetched': 'Osnovni CallMix dohvaćen',
    'Existing CallMix fetched': 'Potojeći CallMix dohvaćen',
    'Save failed': 'Greška kod spremanja',
    'Customer fecthed successfully': 'Korisnik dohvaćen',
    'Updating offer': 'Spremanje izmjena ponude',
    'Saving offer': 'Spremanje ponude',
    'Starting calculation': 'Pokretanje kalkulacije',
    'Enter Call Mix values from attached document.': 'Potrebno je unesti Call Mix iz priloženog dokumenta.',
    'Company name missing': 'Nedostaje ime kompanije',
    'No bundle exists': 'Ponuda nema niti jednu tarifu',
    'Customer data is missing': 'Nedostaju podaci o korisniku',
    'BAN must contain 9 characters': 'BAN mora da sadrži 9 znakova',
    'PIB must contain 9 characters': 'PIB mora da sadrži 9 znakova',
    'MB must contain 8 characters': 'MB mora da sadrži 8 znakova',
    'Duration of offer not selected': 'Nedostaje trajanje ugovorne obaveze',
    'Start date not selected': 'Nedostaje datum početka ugovorne obaveze',
    'No CallMix exists': 'Nedostaje Call Mix',
    ThreeMonths: '3 meseca',
    SixMonths: '6 meseci',
    Inputs: 'Ulazne vrednosti',
    Outputs: 'Izlazne vrednosti',
    Executed: 'Izvršeno',
    'Execution success': 'Izvršeno bez greške',
    'Execution error': 'Greška kod izvršavanja'
};
